import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UserDataStore } from '@/store/user-store/user-data.store';
import { SessionPageComponent } from '../../pages/session-page/session-page.component';
import { LoadingPaeComponent } from '@/shared/loading-pae/loading-pae.component';
import { ArrowLinkComponent } from '@/shared/arrow-link/arrow-link.component';
import { SectionComponent } from '@/shared/section/section.component';
import { SeccionesRolesEnum } from '@/core/enum/RolSeccions.enum';

interface DebugRoleSection {
  enumKey: string;
  section: string;
  assigned: boolean;
}

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SessionPageComponent, LoadingPaeComponent, ArrowLinkComponent, SectionComponent],
  templateUrl: './user-debug.component.html',
})
export default class UserDebugComponent {
  userDataStore = inject(UserDataStore);

  public isSubUser = computed(() => this.userDataStore.isSubUser());

  public isAxionCardView = computed(() => this.userDataStore.isAxionCardView() ?? false);

  public subUserRoleName = computed(() => this.userDataStore.getSubUserRole() ?? 'Sin rol informado');

  public roleSections = computed<DebugRoleSection[]>(() => {
    const sections = this.userDataStore.getSectionsObject() as Record<string, boolean | undefined> | null | undefined;

    return Object.entries(SeccionesRolesEnum)
      .map(([enumKey, section]) => ({
        enumKey,
        section,
        assigned: !!sections?.[section],
      }))
      .sort((a, b) => Number(b.assigned) - Number(a.assigned) || a.section.localeCompare(b.section));
  });

  public assignedRoleSections = computed(() => this.roleSections().filter(role => role.assigned));

  public messageLoading = computed(() => {
    if (!this.userDataStore.isLoaded()) {
      return 'Cargando datos del usuario...';
    }

    return '';
  });
}
